module.exports = "https://web-assets.ifttt.com/packs/media/docs/pinned_applet-53c4ef37.png";